import { GtmCommandsEnum, GtmEventsEnum } from './constants';
import { GtmSetParams, GtmEventParamsMap } from './types';

const gtag = (command: GtmCommandsEnum, ...args: unknown[]) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.gtag?.(command, ...args);
};

export const gtmConfig = (...args: unknown[]) => gtag(GtmCommandsEnum.config, process.env.TRACKING_ID, ...args);

export const gtmSet = (params: Partial<GtmSetParams>) => gtag(GtmCommandsEnum.set, params);

export const gtmEvent = <E extends GtmEventsEnum>(
  event: E,
  ...params: GtmEventParamsMap[E] extends undefined ? [] : [GtmEventParamsMap[E]]
) => gtag(GtmCommandsEnum.event, event, ...params);

type SetUserPropertiesUtilType = {
  wellnessId?: string;
  bornOn?: string;
  gender?: string;
  employerId?: number;
  employerName?: string;
};

export const gtmSetUserProperties = ({
  wellnessId,
  bornOn,
  gender,
  employerId,
  employerName,
}: SetUserPropertiesUtilType) => {
  gtmSet({
    user_properties: {
      user_id: wellnessId,
      wellness_id: wellnessId,
      born_on: bornOn,
      gender: wellnessId ? gender || 'unknown' : undefined,
      employerId: wellnessId ? employerId : '',
      employerName: wellnessId ? employerName : '',
    },
  });
};
